
export enum AgendaOwnerTypeCd {
	SHIPMENTS = 'shipments',
	TRAILERS = 'trailers'}

